export const ukRules = (identifcationNumber) => {
  return true;
};

export const frRules = (identifcationNumber) => {
  if (
    identifcationNumber.length !== 14 ||
    !/^[0-9+]{14}$/i.test(identifcationNumber)
  ) {
    return false;
  }
  return true;
};

export const plRules = (identifcationNumber) => {
  if (identifcationNumber.length !== 10) {
    return false;
  }
  return true;
};

export const chRules = (identifcationNumber) => {
  if (identifcationNumber === "CHE-") return true;
  if (
    identifcationNumber.length !== 15 ||
    !/^(CHE)[0-9 -]*$/i.test(identifcationNumber)
  ) {
    return false;
  }
  return true;
};

export const deRules = (identifcationNumber) => {
  if (
    identifcationNumber.length !== 9 ||
    !/^[0-9a-zA-Z]*$/i.test(identifcationNumber)
  ) {
    return false;
  }
  return true;
};

export const addHyphen = (countryId, identifcationNumber) => {
  // Remove dash (-) if mistakenly entered.
  if (countryId === 8) {
    if (identifcationNumber.length !== 0) {
      const val = identifcationNumber.split("-").join("");
      return val.match(/.{1,3}/g).join("-");
    }
    if (identifcationNumber.length === 0) return "CHE-";
  }
};

export const prefixRegistration = (countryId, identifcationNumber) => {
  return countryId === 8 && (identifcationNumber === "" || !identifcationNumber)
    ? "CHE-"
    : !identifcationNumber
    ? ""
    : identifcationNumber;
};

export const resetIdentifcationNumber = (countryId, identifcationNumber) => {
  return countryId === 8 && identifcationNumber === "CHE-"
    ? ""
    : identifcationNumber;
};

export const identifcationValidation = (countryId, identifcationNumber) => {
  let data = true;
  if (countryId === 1) {
    data = ukRules(identifcationNumber);
  } else if (countryId === 2) {
    data = frRules(identifcationNumber);
  } else if (countryId === 3) {
    data = plRules(identifcationNumber);
  } else if (countryId === 8) {
    data = chRules(identifcationNumber);
  } else if (countryId === 6) {
    data = deRules(identifcationNumber);
  } else {
    data = frRules(identifcationNumber);
  }
  return data;
};
